import { func } from 'prop-types';
import React from 'react';

import ContentColumns from '../components/ContentColumns';

const View4 = (_, { fm }) => {
  return (
    <React.Fragment>
      <ContentColumns
        firstColumn={
          <div>
            <h2>{fm('onlineRehabilitation.rehab8.8.header')}</h2>
            <br />
            {fm('onlineRehabilitation.rehab8.8.text')}
            <br />
            <br />
            {fm('onlineRehabilitation.rehab8.8.thanks')}
          </div>
        }
      />
    </React.Fragment>
  );
};

View4.contextTypes = {
  fm: func,
};

export default View4;
